export default __webpack_public_path__ + "static/assets/fb2c577e007f6931e48e3bfc34341b72.svg";